// dependencies imports ⇒
import React, { useEffect, useState } from "react";
// assets and scss imports ⇒
import "./doctorAndResourceView.scss";
import PlusIcon from "../../../assets/plusIcon.svg";
import MinusIcon from "../../../assets/minusIcon.svg";
import MinusIconDark from "../../../assets/minusIconDark.svg";
import CheckboxWithText from "../Modules/CheckboxWithText";
import SearchBarWithIcon from "../Modules/SearchBarWithIcon";

// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const DoctorAndResourceView = ({
  showNote,
  showTotal,
  doctorResourceList,
  setDoctorResourceList,
  handeQuoteAmount,
}) => {
  // const declarations ⇒
  const [grandTotal, setGrandTotal] = useState(0);
  const [searchString, setSearchString] = useState("");
  const [collapsedId, setCollapsedId] = useState([]);
  // let or var declarations ⇒

  // life cycle methods ⇒
  useEffect(() => {
    if (doctorResourceList?.length > 0) {
      let allSelectedProcedureFee = 0;
      doctorResourceList.forEach((doctorDetails) => {
        if (doctorDetails?.procedureList?.length > 0) {
          doctorDetails.procedureList.forEach((procedure) => {
            if (procedure?.selected) {
              allSelectedProcedureFee += +procedure?.fee;
            } else {
              allSelectedProcedureFee += 0;
            }
          });
        }
      });
      setGrandTotal(allSelectedProcedureFee);
      handeQuoteAmount && handeQuoteAmount(allSelectedProcedureFee);
    }
  }, [doctorResourceList]);

  useEffect(() => {
    setCollapsedId([]);
  }, [searchString]);

  // API Calls ⇒

  // Helper methods ⇒

  const getResourceList = (list) => {
    return list
      .map((data) => {
        if (
          data?.doctorName?.toLowerCase().includes(searchString?.toLowerCase())
        ) {
          const stringExistData = checkIfSearchStringExistInProcedure(data);
          if (stringExistData) {
            return stringExistData;
          }
          return { ...data, procedureList: data?.procedureList };
        } else {
          return checkIfSearchStringExistInProcedure(data);
        }
      })
      .filter(Boolean);
  };

  const checkIfSearchStringExistInProcedure = (data) => {
    if (searchString !== "") {
      const filteredProcedures = data?.procedureList?.filter((procedure) =>
        procedure?.procedureName
          ?.toLowerCase()
          .includes(searchString?.toLowerCase())
      );
      if (filteredProcedures?.length > 0) {
        return {
          ...data,
          procedureList: filteredProcedures,
          isExpanded: collapsedId.includes(data.doctorId) ? false : true,
        };
      } else return null;
    }
    return false;
  };

  // Actions ⇒
  const handleExpandCollapse = (doctorDetails) => {
    let index = doctorResourceList?.findIndex(
      (data) => data?.doctorId === doctorDetails?.doctorId
    );
    if (index > -1) {
      if (doctorDetails.isExpanded) {
        let arr = [...collapsedId];
        arr.push(doctorDetails?.doctorId);
        setCollapsedId(arr);
      } else {
        let arr = collapsedId;
        setCollapsedId(arr.filter((elem) => elem !== doctorDetails?.doctorId));
      }
      doctorResourceList[index].isExpanded =
        !doctorResourceList[index].isExpanded;
      setDoctorResourceList([...doctorResourceList]);
    }
  };

  const handleProcedure = (doctorDetails, procedure) => {
    let index = doctorResourceList?.findIndex(
      (data) => data?.doctorId === doctorDetails?.doctorId
    );
    if (index > -1) {
      let procedureIndex = doctorResourceList[index]?.procedureList?.findIndex(
        (data) => data?.procedureId === procedure?.procedureId
      );
      if (procedureIndex > -1) {
        doctorResourceList[index].procedureList[procedureIndex].selected =
          !doctorResourceList[index].procedureList[procedureIndex].selected;

        doctorResourceList[index].procedureList[
          procedureIndex
        ].is_followup_schedule = false;

        doctorResourceList[index].selectAll = doctorResourceList[
          index
        ].procedureList?.every((data) => data?.selected);
        setDoctorResourceList([...doctorResourceList]);
      }
    }
  };

  const handleSelectAllProcedure = (doctorDetails) => {
    const finalList = getResourceList(doctorResourceList);
    const tempDoctorProcedureList = finalList.find(
      (elem) => elem?.doctorId === doctorDetails?.doctorId
    );
    let index = doctorResourceList?.findIndex(
      (data) => data?.doctorId === doctorDetails?.doctorId
    );
    if (index > -1) {
      doctorResourceList[index].selectAll =
        !doctorResourceList[index].selectAll;
      doctorResourceList[index].procedureList.forEach((data) => {
        if (searchString) {
          if (
            tempDoctorProcedureList?.procedureList.some(
              (elem) => elem.procedureId === data.procedureId
            )
          ) {
            data.selected = doctorResourceList[index].selectAll;
          }
        } else {
          data.selected = doctorResourceList[index].selectAll;
        }
      });
      doctorResourceList[index].isExpanded = true;
      setDoctorResourceList([...doctorResourceList]);
    }
  };

  const handleSearchString = (val) => {
    setSearchString(val);
  };

  const handleDeselectAllProcedures = (doctorDetails) => {
    let index = doctorResourceList?.findIndex(
      (data) => data?.doctorId === doctorDetails?.doctorId
    );
    if (index > -1) {
      doctorResourceList[index].selectAll = false;
      doctorResourceList[index].procedureList.forEach((data) => {
        data.selected = false;
      });
      doctorResourceList[index].isExpanded = true;
      setDoctorResourceList([...doctorResourceList]);
    }
  };

  const handleCheckSelectedProcedure = (doctorDetails) => {
    return doctorResourceList?.some(
      (item) =>
        item?.doctorId === doctorDetails?.doctorId &&
        item.procedureList.some((procedure) => procedure.selected)
    );
  };
  const handleCheckAllSelectedProcedure = (doctorDetails) => {
    return doctorResourceList?.some(
      (item) =>
        item?.doctorId === doctorDetails?.doctorId &&
        item.procedureList.length > 0 &&
        item.procedureList.every((procedure) => procedure.selected)
    );
  };

  const getInitials = (name) => {
    if (!name) return "";
    const cleanName = name.replace(
      /^(Dr\.?|Mr\.?|Ms\.?|Mrs\.?|Prof\.?|Er\.?)\s+/i,
      ""
    );
    const words = cleanName.trim().split(/\s+/);
    let initials = words[0][0].toUpperCase();
    if (words.length > 1) {
      initials += words[words.length - 1][0].toUpperCase();
    }
    return initials;
  };

  const getHighlightedText = (text, search) => {
    if (!search) return text;

    const regex = new RegExp(`(${search})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <strong key={index}>{part}</strong>
      ) : (
        part
      )
    );
  };

  // create UI ⇒
  const displayDoctorInitials = (name, initialStyle) => {
    return (
      <div className="drvc-doctor-name-initial-container" style={initialStyle}>
        <div>{getInitials(name)}</div>
      </div>
    );
  };

  const displayDoctorAndResourceView = () => {
    const finalList = getResourceList(doctorResourceList);
    return (
      <div className="drvc-main-container">
        {finalList?.map((doctorDetails, index) => (
          <div className="drvc-droctor-with-procedure-list" key={index}>
            <div
              className="drvc-header-container"
              onClick={(e) => {
                e.stopPropagation();
                handleExpandCollapse(doctorDetails);
              }}
            >
              <div className="drvc-checkbox-with-title">
                {doctorDetails?.isExpanded &&
                  (handleCheckAllSelectedProcedure(doctorDetails) ||
                    !handleCheckSelectedProcedure(doctorDetails)) && (
                    <div className="drvc-checkbox-with-title-div">
                      <CheckboxWithText
                        selected={doctorDetails?.selectAll}
                        handleChange={() => {
                          handleSelectAllProcedure(doctorDetails);
                        }}
                      />
                    </div>
                  )}
                {doctorDetails?.isExpanded &&
                  !handleCheckAllSelectedProcedure(doctorDetails) &&
                  handleCheckSelectedProcedure(doctorDetails) && (
                    <button
                      className="drvc-collaps-expand-button drvc-light-border"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeselectAllProcedures(doctorDetails);
                      }}
                    >
                      <img src={MinusIcon} alt="" />
                    </button>
                  )}
                {!doctorDetails?.isExpanded &&
                  displayDoctorInitials(
                    doctorDetails?.doctorName,
                    doctorDetails?.initialsStyle
                  )}
                <p className="drvc-doctor-resource-name">
                  {getHighlightedText(doctorDetails?.doctorName, searchString)}
                </p>
              </div>
              <div className="drvc-collaps-expand-button-container">
                <button
                  className="drvc-collaps-expand-button drvc-dark-border"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleExpandCollapse(doctorDetails);
                  }}
                >
                  {doctorDetails?.isExpanded ? (
                    <img src={MinusIconDark} alt="" />
                  ) : (
                    <img src={PlusIcon} alt="" />
                  )}
                </button>
              </div>
            </div>
            {doctorDetails?.isExpanded && (
              <div className="drvc-procedure-list-container">
                {doctorDetails?.procedureList?.map((procedure, pindex) => (
                  <div className="drvc-checkbox-with-title" key={pindex}>
                    <div className="drvc-checkbox-with-title-div">
                      <CheckboxWithText
                        selected={procedure?.selected}
                        handleChange={() =>
                          handleProcedure(doctorDetails, procedure)
                        }
                      />
                    </div>
                    <p
                      className="drvc-procedure-name"
                      onClick={() => handleProcedure(doctorDetails, procedure)}
                    >
                      {getHighlightedText(
                        procedure?.procedureName,
                        searchString
                      )}
                      <span className="drvc-procedure-fee">
                        {" "}
                        - ₹{procedure?.fee}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const displaySearchBar = () => {
    return (
      <div className="drvc-search-container">
        <SearchBarWithIcon
          placeholder={"Search by doctor name and Procedure"}
          inputCallBack={handleSearchString}
          isClearable={true}
          search_string={searchString}
        />
      </div>
    );
  };

  const displayTotal = () => {
    return (
      <div className="drv-grand-total-container">
        <div className="drv-grand-total-text">
          <p>Grand Total</p>
        </div>
        <div className="drv-grand-total-value">
          <p>{grandTotal?.toLocaleString()}</p>
        </div>
      </div>
    );
  };

  const displayNote = () => {
    return (
      <div className="drv-note-container">
        <div className="drv-note-text">
          <p>NOTE: Kindly select a procedure to proceed</p>
        </div>
      </div>
    );
  };
  return (
    <div
      className={
        "doctor-resource-view-container " +
        (showNote ? "doctor-resource-view-container-with-note" : "")
      }
    >
      {displaySearchBar()}
      {displayDoctorAndResourceView()}
      {showTotal && displayTotal()}
      {showNote && displayNote()}
    </div>
  );
};

// export ⇒

export default DoctorAndResourceView;
